import {
  CloseOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  PrinterOutlined,
  SaveOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Select, Space, Tag, Form as AntForm, Menu  } from "antd";
import axios from "axios";
import {
  Button,
  DeleteButton,
  Form,
  Modal,
  Table,
  TableCard,
  Input,
  Drawer,
  Export,
} from "components";
import React, { useEffect, useState } from "react";
import { FaPen, FaPlus, FaDownload, FaFilter, FaCaretRight, FaMinus, FaTrash, FaRegSquareCheck } from "react-icons/fa6";
import { Link } from "react-router-dom";
import searchFields from "./searchFields";
import dayjs from "dayjs";
import { CgScrollH } from "react-icons/cg";
import { Option } from "antd/es/mentions";
import EditableTable from "modules/editable";
import ExcelRender from "modules/components/ExcelRender";
const { Item } = Menu;

const type = [
  { label: "Ажлахгүй", value: "Ажлахгүй" },
  { label: "Бүтэн", value: "Бүтэн" },
  { label: "Хагас", value: "Хагас" },
];

  const status = [

    { label: <Tag color="success">Энгийн</Tag>, value: 1 },
    { label: <Tag color="processing">Цагтай</Tag>, value: 2 },
    { label: <Tag color="orange">Яаралтай</Tag>, value: 3 },
    { label: <Tag color="volcano">Онц яаралтай</Tag>, value: 4 },
  ];
function Delivery() {
  const [data, setData] = useState([]);
  const [showHeaders, setShowHeaders] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [productData, setProductData] = useState([]);
  const [costumer, setCostumer] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [editData, setEditData] = useState(null);
  const [payment, setPayment] = useState([]);
  const [price, setPrice] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [form] = Form.useForm();
  const [ header, setHeader ] = useState([]);
  const [ cols, setCols ] = useState([]);
  const [ openModalFileEdit, setOpenModalFileEdit ] = useState(false);
  const [ openModal, setOpenModal ] = useState(false);
  const [filterForm] = Form.useForm();
  console.log(editData);

  useEffect(() => {
    getData();
    getWarehouse();
    getProducts();
    getCostumer();
    getPayment();
  }, []);

  const getData = () => {
    setLoading(true);
    axios({
      method: "get",
      // url: "orders",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) => tmp.push({ 
          ...item, 
          deliverydate: dayjs(item.deliverydate),
          createdAt: dayjs(item.createdAt),
          orderdate: dayjs(item.orderdate),
          statusdate: dayjs(item.statusdate),
          updatedAt: dayjs(item.updatedAt),
        }))
        let filteredData = tmp.filter((item) => item.status === 3);
        setData(filteredData)
      })
      .catch((err) => {})
      .finally(() => setLoading(false));
  };

  const getProducts = () => {
    axios({
      method: "get",
      url: "/products",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: parseInt(item.id),
            label: item.name,
            id: item.id,
            text: item.name,
            price: item.price
          }
          )
        );
        setProductData(tmp);
      })
      .catch(() => {});
  };
    const getCostumer = () => {
    axios({
      method: "get",
      url: "/customers",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: parseInt(item.id),
            label: item.name,
            text: item.name,
          })
        );
        setCostumer(tmp);
      })
      .catch(() => {});
  };
  const getPayment = () => {
    axios({
      method: "get",
      url: "/paymenttypes",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: parseInt(item.id),
            label: item.name,
            text: item.name,
          })
        );
        setPayment(tmp);
      })
      .catch(() => {});
  };
  const getWarehouse = () => {
    axios({
      method: "get",
      url: "/warehouses",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: parseInt(item.id),
            label: item.name,
            text: item.name,
          })
        );
        setWarehouse(tmp);
      })
      .catch(() => {});
  };

  const columns = [
    {
      title: "№",
      dataIndex: "No",
      key: "No",
      width: 50,
      align: "center",
      cellRender: (e) => <span>{e.rowIndex + currentPage + 1}</span>,
    },
    {
      title: "Гарчиг",
      dataIndex: "title",
      key: "title",
      cellRender: ({value, data}) => (
        <Link to={`/order/${data?.id}`}><div className="flex flex-row">
         <div className="action-cell flex items-center gap-2"><FaCaretRight />
        </div>{value}
        </div></Link>
      )
    },
    {
      title: "Харилцагч",
      dataIndex: "customerid",
      key: "customerid",
      cellRender:({value, data}) =>(
        <div>{costumer.find((item) => item?.value === value)?.label}</div>     
      ) 
    },
    {
      title: "Төлбөрийн төлөв",
      dataIndex: "paymentid",
      key: "paymentid",
      cellRender:({value, data}) =>(
        <div>{payment.find((item) => item?.value === value)?.label}</div>     
      ) 
    },
    {
      title: "Төлсөн дүн",
      dataIndex: "payedamount",
      key: "payedamount",
    },
    // {
    //   title: "Төлөв",
    //   dataIndex: "status",
    //   key: "status",
    //   cellRender:({value, data}) =>(
    //     <div>{status.find((item) => item?.value === value)?.label}</div>     
    //   ) 
    // },
    {
      title: 'Төлөв өөрчлөх',
      dataIndex: 'status',
      key: 'status',
      cellRender: ({ value, data }) => {         
      const currentIndex = status.find(item => item.value === value);
      const nextOption = status.slice(currentIndex.value);
      console.log(nextOption, "nextOption");
      return (
        <Space size="middle" className="">
        
        <Dropdown
          overlay={
            <Menu onClick={({ key }) => handleChange(key, data)}>
              {nextOption.map(option => (
                  <Item key={option.value}>{option.label}</Item>
                ))}
            </Menu>
          }
        >
          <a>{currentIndex?.label}
            {/* <DownOutlined /> */}
          </a>
          
        </Dropdown>
      </Space>
        );
      },
    },
    

    // {
    //     title: 'Огноо',
    //     dataIndex: 'end_date',
    //     key: 'end_date',
    //     cellRender: ({value, data}) => (
    //         <>{dayjs(value).format('YYYY-MM-DD')}</>
    //     )
    // },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: 90,
      cellRender: ({ value, data }) => (
        <div className="action-cell flex items-center gap-2">
          <Button
            type="ghost"
            size="sm"
            icon={<FaPen />}
            onClick={() => handleEditButton(data)}
          />
          <DeleteButton onClick={() => handleDelete(data)} />
        </div>
      ),
    },
  ];
  const columnsForm = (name) => {
    return [
      // {
      //   title: "№",
      //   dataIndex: "No",
      //   key: "No",
      //   width: 50,
      //   align: "center",
      //   cellRender: (e) => <span>{e.rowIndex + currentPage + 1}</span>,
      // },
      {
        title: 'Бараа',
        dataIndex: 'productid',
        key: 'productid',
        cellRender: ({value, data, record}) => (<>
        <Form.Item
            name={[name, "productid"]}
              > 
          <Select 
              placeholder="Бараа"  
              className='border'
              onChange={value => handleSelectChange(value, data.key, 'product')}
            >
              {productData.map((opt) => (
                <Option
                  key={opt.value}
                  value={opt.value}
                  label={opt.label}
                >
                  {opt.label} - {opt.price}
                </Option>
              ))}
            </Select>
            </Form.Item>   
         </>
         )
      },
      {
        title: 'Агуулах',
        dataIndex: 'warehouseid',
        key: 'warehouseid',
        cellRender: ({value, data,record}) => (
          <Form.Item
                name={[name, "warehouseid"]}
                
                  >
              <Select placeholder="Агуулах" className='border '
                onChange={value => handleSelectChange(value, record.key, 'product')}
  
              >
              {warehouse.map((opt) => (
                  <Option
                      key={opt.value}
                      value={opt.value}
                    label={opt.label}
                    >
                      {opt.label}  
                  </Option>
              ))}
              </Select>
          </Form.Item>
        ),
      },
      {
        title: 'Тоо ширхэг',
        dataIndex: 'qty',
        key: 'qty',
        cellRender: ({value, data}) => (
          <Form.Item
            name={[name, 'qty']}
            rules={[
              {
                required: true,
                message: 'Qty код оруулна уу',
              },
            ]}
          >
            <Input 
            className='border'
            style={{ height: '30px' }}
            onChange={(e) => {
                const quantity = parseInt(e.target.value);
                const selectedProduct = productData.find(product => product.value === form.getFieldValue(['products', 'productid']));
                if (selectedProduct && !isNaN(quantity) && !isNaN(selectedProduct.price)) {
                  const price = selectedProduct.price;
                  const totalAmount = quantity * price;
                  console.log(totalAmount);
                  form.setFieldValue(['products', 'totalamount'], totalAmount);
                }
              }}
            />
          </Form.Item>
        ),
      },
      {
        title: 'Нийт дүн',
        dataIndex: 'totalamount',
        key: 'totalamount',
        cellRender: ({value, data}) => (
          <Form.Item
            name={[name, 'totalamount']}
          >
            <Input 
            style={{ height: '30px' }}
            className='border'
            readOnly 
              value={form.getFieldValue(['products', 'totalamount']) || 0} 
            />
          </Form.Item>
        ),
      },
      {
        title: '',
        dataIndex: 'action',
        key: 'action',
        width: 90,
        cellRender: ({value,data}) => (
          <div className='action-cell flex items-center gap-2'>
            <DeleteButton onClick={() => handleDeleteRow(data?.key)}/>
          </div>
        )
      }
    ];

  } 
  const handleDeleteRow = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
  };
  const handleSelectChange = (value, key, dataIndex) => {
    setDataSource(prevDataSource => {
      const newData = prevDataSource.map(item => {
        if (item.key === key) {
          return { ...item, [dataIndex]: value }; 
        }
        return item;
      });
      return newData;
    });
  };

  const handleChange = (value, record) => {
    setActionLoading(true);
    axios({
      method: "put",
      url: `/order/status`,
      data: {
          id: record.id,
          status: value,
      }
    })
      .then((res) => {
        getData();
      })
      .catch((err) => {})
      .finally(() => {
        setActionLoading(false);
      });
      
    const newData = data.map(item => {
      if (item.key === record.key) {
        return { ...item, status: value };
      }
      return item;
    });
    setData(newData);
  };
  const fields = [
    {
      label: "Илгээмжийн мэдээлэл",
      name: "title",
      rules: [{ required: true, message: "Илгээмжийн мэдээлэл оруулна уу" }],
      className: "col-span-6 mb-1",
      inputProps: {},
    }, 
   {
      label: "Захиалгын код",
      name: "customerid",
      rules: [{required: true, message: 'Захиалгын код оруулна уу'}],
      className: "col-span-6 mb-1",
      inputProps: {
      },
    },   
     {
      label: "Хүлээн авагчийн нэр",
      name: "paymentid",
      rules: [{required: true, message: 'Хүлээн авагчийн нэр оруулна уу'}],
      className: "col-span-6 mb-1",
      inputProps: {
      },
    },
    {
      label: "Төрөл",
      name: "type",
      type: "select",
      rules: [{required: true, message: 'Төрөл оруулна уу'}],
      className: "col-span-6 mb-1",
      inputProps: {
        options: status
      },
    },
    {
      label: "Утас",
      name: "payedamount",
      type: "number",
      rules: [{required: true, message: 'Утас оруулна уу'}],
      className: "col-span-6 mb-1",
      inputProps: {
      },
    },
    {
      label: "Утас 2",
      name: "payedamount2",
      type: "number",
      rules: [{required: true, message: 'Утас оруулна уу'}],
      className: "col-span-6 mb-1",
      inputProps: {
      },
    },
   
    {
      label: "Барааны тооцоо",
      name: "description",
      // rules: [{ required: true, message: 'Тайлбар оруулна уу' }],
      className: "col-span-6 mb-1",
      inputProps: {},
    },
    {
      label: "Барааны төрөл",
      name: "description",
      type: "select",
      // rules: [{ required: true, message: 'Тайлбар оруулна уу' }],
      className: "col-span-6 mb-1",
      inputProps: {
        options: type
      },
    },
    {
      label: "Дэлгэрэнгүй хаяг",
      name: "deliverydate",
      type: "textarea",
      rules: [{ required: true, message: 'Дэлгэрэнгүй хаяг оруулна уу' }],
      className: "col-span-6 mb-1",
      inputProps: {},
    },
    {
      label: "Тайлбар",
      name: "description",
      type: "textarea",
      // rules: [{ required: true, message: 'Тайлбар оруулна уу' }],
      className: "col-span-6 mb-1",
      inputProps: {},
    },
    {
      label: "Байршил сонгох",
      name: "orderdate",
      rules: [{ required: true, message: 'Байршил сонгох оруулна уу' }],
      className: "col-span-6 mb-1",
      inputProps: {},
    },
    {
      label: "Овор хэмжээ сонгох",
      name: "orderdate",
      rules: [{ required: true, message: 'Овор хэмжээ сонгох оруулна уу' }],
      className: "col-span-6 mb-1",
      inputProps: {},
    },
    // {
    //   label: "Энэ захиалгыг баталгаажуулах бол энд дарна уу",
    //   name: "prove",
    //   type: "check",
    //   // rules: [{ required: true, message: 'Тайлбар оруулна уу' }],
    //   className: "col-span-12 mb-1",
    //   inputProps: {},
    // },
    {
      type: 'component',
      fieldName: 'type1',
      component: (
        <div className="col-span-12">
        {/* {showUploadDialog && ( */}
        <Form.List name='order_details'>
            {/* <div>
              Upload Dialog Content
              <button onClick={() => setShowUploadDialog(false)}>Close</button>
            </div> */}
          {(fields, { add, remove }) => (
            
            <div className="col-span-12">
              <table className='col-span-12 mt-6 items-center  rounded-lg border-separate border-spacing-2 border border-slate-200'>
                <thead className="items-center mt-2" style={{ display: fields.length > 0 ? 'table-header-group' : 'none' }}>
                  <tr >
                    <th style={{ width: '5%' }}></th>
                    <th style={{ width: '25%' }}>Бараа</th>
                    <th style={{ width: '5%' }}>Үнэ</th>
                    <th style={{ width: '25%' }}>Агуулах</th>
                    <th style={{ width: '15%' }}>Тоо ширхэг</th>
                    <th style={{ width: '15%' }}>Нийт дүн</th>
                    <th style={{ width: '10%' }}></th>
                  </tr>
                </thead>
                <tbody >
                  {fields.map((field, index) => (
                    <tr key={field.key} >
                      <td style={{ width: '5%' }}>
                        <div className="mb-6">
                          {index + 1}
                        </div>
                      </td>
                      <td style={{ width: '25%' }}>
                      <Form.Item name={[index, 'productid']}  >
                      <Select
                        placeholder="Бараа сонгоно уу"
                        onChange={(value) => {
                        const selectedProduct = productData.find((product) => product.value === value);
                        if (selectedProduct) {
                          form.setFieldValue(['order_details', index, 'price'], selectedProduct.price);
                        }
                        }}
                        >
                        {productData.map((opt) => (
                        <Option key={opt.value} value={opt.value} label={opt.label}>
                          {opt.label}
                        </Option>
                        ))}
                        </Select>
                      </Form.Item>
                      </td>
                      <td style={{ width: '5%' }}><Form.Item name={[index, 'price']}>
                          <Input className='border h-8' readOnly />
                          </Form.Item></td>
                      <td style={{ width: '25%' }}>
                        <Form.Item name={[index, 'warehouseid']}>
                          <Select placeholder="Агуулах сонгоно уу">
                          {warehouse.map((opt) => (
                            <Option key={opt.value} value={opt.value} label={opt.label}>
                              {opt.label}
                            </Option>
                          ))}
                          </Select>
                        </Form.Item>
                      </td>
                      <td style={{ width: '15%' }}>
                      <Form.Item
                        name={[ index, 'qty']}
                        rules={[
                          {
                            required: false,
                            message: 'Qty код оруулна уу',
                          },
                        ]}
                      >
                        <Input 
                          className="border h-8"
                          onChange={(e) => {
                            const quantity = parseInt(e.target.value);
                            const productId = form.getFieldValue(['order_details', index, 'productid']); 
                            const selectedProduct = productData.find(product => product.id === productId); 
                            if (selectedProduct && !isNaN(quantity) && !isNaN(selectedProduct.price)) {
                              const totalAmount = quantity * selectedProduct.price;
                              setPrice(totalAmount)
                              form.setFieldValue(['order_details', index, 'totalamount'], totalAmount);
                            }
                          }}
                        />
                      </Form.Item>
                      </td>
                      <td style={{ width: '15%' }}>
                      <Form.Item name={[ index, 'totalamount']} >
                        <Input className='border h-8' />
                      </Form.Item>
                      </td>
                      <td style={{ width: '10%' }}>
                      <Button icon={<FaTrash/>} className='flex items-center mb-6 cursor-pointer justify-center bg-[#F0F1F3] rounded-md' onClick={() => remove(field.name)}/>                      </td>
                    </tr>
                  ))}
                </tbody>
                     
              </table> 
              <Button className='w-full mt-2 ' iconPosition='right' onClick={() => { add(); }}>
                        Бараа нэмэх
              </Button>
             

            </div>
          )}
        </Form.List>
      </div>
      )
    },  
  ];
  const   handleSubmit = (values) => {
    setActionLoading(true);
    if (editData) {
      axios({
        method: "put",
        // url: `/order`,
        data: {
          ...values,
          id: parseInt(editData.id),
        },
      })
        .then((res) => {
          getData();
          handleCancel();
        })
        .catch((err) => {})
        .finally(() => {
          setActionLoading(false);
        });
    } else {
      axios({
        method: "post",
        // url: `/order`,
        data: {
          ...values,
          status: 1,
          order_details:[
            ...values.order_details,
          ]
        },
      })
        .then((res) => {
          getData();
          handleCancel();
        })
        .catch((err) => {

        }).finally(() => {
          setActionLoading(false);
        });
    }
  };  

  const handleAddButton = (data) => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditButton = (data) => {
    setEditData(data);
    setShowModal(true);
    form.setFieldsValue({
      title: data.title,
      customerid: data.customerid,
      paymentid: data.paymentid,
      payedamount: data.payedamount,
      status: data.status,
      orderdate: data.orderdate,
      deliverydate: data.deliverydate,
      description: data.description,
      prove: data.prove,
      order_details: data.order_details, 
    });
  };

  const handleDelete = (data) => {
    setActionLoading(true);
    axios({
      method: "delete",
      url: `/order/${data.id}`,
    })
      .then((res) => {
        getData();
        handleCancel();
      })
      .catch((err) => {})
      .finally(() => {
        setActionLoading(false);
      });
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setEditData(null);
    setShowHeaders(false);
  };

  const handleCancel = () => {
    setShowModal(false);
    if (editData) {
      setEditData(null);
    } else {
      form.resetFields();
    }
  };

  const handleFilterSubmit = (values) => {
    setLoading(true);
    axios({
      method: "get",
      url: `/job_ad_  search?name=${values.name}&purpose=${values.purpose}&departmentid=${values.departmentid}&requirements=${values.requirements}&positionid=${values.positionid}&job_time=${values.job_time}&end_date=${values.end_date}`,
    })
      .then((res) => {
        setData(res.data);
        setFilterOpen(false);
      })
      .catch((err) => {})
      .finally(() => setLoading(false));
  };
  const handleOpenFile = () => {
    setOpenModalFileEdit(true);
  };

  const handleCloseFileModal = () => {
    setOpenModalFileEdit(false);
  };
  const handleOpenModalFileEdit = () => {
    setOpenModalFileEdit(true);
  };

  const handleOpenCloseModalFileEdit = () => {
    setOpenModalFileEdit(false);
  };

  const handleFileSubmit = (values, method) => {
    let tmp = [];
    cols.forEach((item, i) => {
        if (i !== 0) {
            let nameIndex = header.indexOf('name'); 
            let name = item[nameIndex];
            tmp.push({
                name: name,
            });
        }
    });
    if(method ===  'post'){
      if(data?.type === 0){
        setLoading(true);
        axios({
          method: 'post',
          url: '/brand',
         
            data: tmp,
          
        }).then(() => {
          getData();
          handleCloseFileModal();
        }).catch((err) => {
        }).then(() => setLoading(false))
      } 
      else {
        setLoading(true)
        axios({
          method: 'post',
          url: '/brand',
        
            data: tmp,
        
        }).then(() => {
          getData();
          handleCloseFileModal();
        }).catch((err) => {
        }).then(() => setLoading(false))
      }
    }
    else {
      if(data?.type === 0){
        setLoading(true);
        axios({
          method: 'put',
          url: '/brand',
        
            data: tmp,
       
        }).then(() => {
          getData();
          handleOpenCloseModalFileEdit();
        }).catch((err) => {
        }).then(() => setLoading(false))
      }
      else {
        setLoading(true)
        axios({
          method: 'put',
          url: '/brand',
            data: tmp,
       
        
        }).then(() => {
          getData();
          handleOpenCloseModalFileEdit();
        }).catch((err) => {
          
          
        }).then(() => setLoading(false))
      }
    };
  };
  return (
    <TableCard
      header={
        <div className="flex flex-col">
          <div className="w-full flex justify-between items-center gap-4">
            <h1 className="text-2xl font-medium">Хүргэлтийн жагсаалт</h1>
            <div className="flex items-center gap-2">
              <Button icon={<FaFilter/>} onClick={() => setFilterOpen(true)}>Шүүлтүүр</Button>
              <Export
                fileData={data} 
                fileName={'Захиалга'} 
              />
              <Button
                icon={<PrinterOutlined className=''/>}
                onClick={handleOpenFile}
              >Excel оруулах</Button>
              <Button
                type="primary"
                icon={<FaPlus />}
                onClick={handleAddButton}
              >
                Нэмэх
              </Button>
            </div>
          </div>
        </div>
      }
    >
      <Table dataSource={data} columns={columns} loading={loading} />
      <Modal
        style={{ maxWidth: "80%", minWidth: "70%" }}
        title={editData ? "Засах" : "Шинээр нэмэх"}
        open={showModal}
        onCancel={handleCloseModal}
      >
        <Form
          form={form}
          fields={fields}
          editData={editData}  
          initialValues={editData}  
          onFinish={handleSubmit}
          className={"gap-2"}
        >
          <div className="col-span-12 flex justify-end items-center gap-2 mt-5">
            <Button
              type="primary"
              onClick={() => form.submit()}
              loading={actionLoading}
              icon={<SaveOutlined />}
            >
              Хадгалах
            </Button>
            <Button onClick={handleCancel} disabled={actionLoading}>
              Цуцлах
            </Button>
          </div>
        </Form>
      </Modal>
      <Drawer open={filterOpen} onClose={() => setFilterOpen(false)}>
        <div>
          <h1 className="text-xl text-black-text font-bold">Шүүх</h1>
          <Form
            form={filterForm}
            fields={searchFields()}
            onFinish={handleFilterSubmit}
            className="gap-4"
          />
          <Button
            className="w-full mt-4"
            size="sm"
            type="primary"
            onClick={() => filterForm.submit()}
          >
            Хайх
          </Button>
        </div>
      </Drawer>
      <Modal
          title={<div className="text-lg uppercase">{'Брэнд excel оруулах'}</div>}
          open={openModalFileEdit}
          onCancel={handleOpenCloseModalFileEdit}
          width={1200}
          destroyOnClose
          footer={false}
        >
          <AntForm
            form={form}
            onFinish={(values) => handleFileSubmit(values, 'post')} 
          >
            <AntForm.Item>
              <ExcelRender header={header} setHeader={setHeader} cols={cols} setCols={setCols} />
            </AntForm.Item>
            <AntForm.Item>
              <div className="flex justify-end">
                <Button
                  type="primary"
                  onClick={() => form.submit()}
                  loading={actionLoading}
                  icon={<SaveOutlined />}
                >
                  Хадгалах
                </Button>
              </div>
            </AntForm.Item>
          </AntForm>
        </Modal>
    </TableCard>
  );
}

export default Delivery;
